import { cn } from "@/lib/utils";

const GREEN = ["approved", "passed", "matched", "posted", "completed", "quoted", "read", "active", "verified", "compliant",
  "recommended", "final", "issued", "received", "reconciled", "qualified", "answered", "disposed", "fully recovered",
  "released", "closed", "submitted", "actualised", "grn created", "sap posted", "yes"];
const AMBER = ["pending", "review", "in progress", "in_progress", "draft", "open", "delivered", "planned", "requested",
  "in transit", "scheduled", "applied", "under", "identified", "at gate", "partially", "approved for sale", "returned"];
const ROSE = ["rejected", "mismatch", "bounced", "on hold", "non-compliant", "no response", "discrepancy", "variance",
  "cancelled", "blocked", "disqualified", "expired", "returned to vendor", "superseded", "inactive", "breached", "no"];

export const tone = (s) => {
  const v = String(s || "").toLowerCase();
  if (v.includes("msme")) return "indigo";
  if (ROSE.some((k) => v === k || v.startsWith(k))) return "rose";
  if (GREEN.some((k) => v === k)) return "green";
  if (AMBER.some((k) => v.startsWith(k)) || v.includes("approval") || v.includes("review")) return "amber";
  return "slate";
};

const CLS = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  rose: "bg-rose-50 text-rose-700 border-rose-200",
  indigo: "bg-blue-50 text-blue-700 border-blue-200",
  slate: "bg-slate-100 text-slate-700 border-slate-200",
};

export const StatusBadge = ({ value, className, testId }) => (
  <span
    data-testid={testId}
    className={cn("inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium", CLS[tone(value)], className)}
  >
    {value}
  </span>
);
